import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";

export default function ProtectedRoute({ children, requireAdmin = false }) {
    const { user, checking } = useAuth();
    const location = useLocation();

    if (checking) {
        return (
            <div className="min-h-[60vh] flex items-center justify-center">
                <div className="font-display text-2xl">Cargando…</div>
            </div>
        );
    }
    if (!user) {
        return <Navigate to="/login" state={{ from: location.pathname }} replace />;
    }
    if (requireAdmin && user.role !== "admin") {
        return <Navigate to="/dashboard" replace />;
    }
    return children;
}
